/* Help dropdown — open/close and placement.

   The open/close contract is deliberately identical to wb-brand-menu.js
   (button + `.is-open`, `.is-shut` applied after the fade, Escape and
   outside-click here rather than in a custom element). Kept as its own file
   rather than generalised: the two differ in the one place that matters —
   this is a small anchored dropdown, that is a full-width band — and a
   shared abstraction would hide exactly that difference. If a third dropdown
   appears, extract then. */
(() => {
  const place = (root) => {
    const toggle = root.querySelector('[data-wbh-toggle]');
    const panel = root.querySelector('.wb-help__panel');
    if (!toggle || !panel) return;
    const r = toggle.getBoundingClientRect();
    /* ⚠ Guard the zero: a collapsed or not-yet-laid-out viewport reports 0
       for every rect, and writing that would park the panel in the corner. */
    if (r.width === 0 && r.height === 0) return;
    panel.style.top = Math.round(r.bottom + 10) + 'px';
    /* ⚠ Hung off the trigger's LEFT edge, not its right. Right-aligning put
       the whole 232px mass to the LEFT of "Help" — and since Help is not the
       last item in the row (the country selector sits to its right) the panel
       floated mid-row, pointing at nothing. Dropping from the left edge makes
       the first character land under the H, which is the tether (Owen,
       2026-08-14).
       Still clamped to the viewport, so a trigger near the right edge pulls
       the panel back inside instead of off-screen. */
    const width = panel.offsetWidth || 232;
    const left = Math.min(
      Math.max(8, Math.round(r.left)),
      Math.max(8, window.innerWidth - width - 8)
    );
    /* ⚠ Clear `right` when setting `left`. The stylesheet anchors the resting
       panel with `right`, and a fixed box given BOTH edges stretches to span
       them instead of keeping its own width. */
    panel.style.left = left + 'px';
    panel.style.right = 'auto';
  };

  const init = () => {
    document.querySelectorAll('[data-wbh-root]').forEach((root) => {
      const toggle = root.querySelector('[data-wbh-toggle]');
      const panel = root.querySelector('.wb-help__panel');
      if (!toggle || !panel) return;

      let shutTimer = null;

      const open = () => {
        clearTimeout(shutTimer);
        panel.classList.remove('is-shut');
        place(root);
        /* ⚠ Forced reflow, NOT requestAnimationFrame. rAF can be delayed
           indefinitely or never fire in a throttled tab, leaving the panel
           with is-shut removed and is-open never added: visible, unclipped
           and stuck. */
        void panel.offsetWidth;
        root.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      };

      const close = () => {
        if (!root.classList.contains('is-open')) return;
        root.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        /* Timeout rather than transitionend: a panel closed off-screen or
           under reduced motion may never fire the event, and would stay
           clickable forever. */
        clearTimeout(shutTimer);
        shutTimer = setTimeout(() => panel.classList.add('is-shut'), 200);
      };

      panel.classList.add('is-shut');

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        root.classList.contains('is-open') ? close() : open();
      });

      document.addEventListener('click', (e) => {
        if (!root.classList.contains('is-open')) return;
        if (root.contains(e.target)) return;
        close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
        close();
        toggle.focus();
      });

      addEventListener('scroll', () => root.classList.contains('is-open') && place(root), { passive: true });
      addEventListener('resize', () => root.classList.contains('is-open') && place(root), { passive: true });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
